module.exports = __webpack_public_path__ + "Banner_ModuleWrapup-434d4e68e0f8b5b5bc119a1460522eb3.svg";